// extracted by mini-css-extract-plugin
module.exports = {"togglePanelWrap":"TogglePanel_togglePanelWrap__1l9n7"};